//import Sounder from "./Tools/sounder/Sounder";
import Assets from "./Tools/Assets";
import Config from "./Tools/Config";
import Sprites from "./Tools/Sprites";
import ScreenStage from "./ScreenStage";
import Pqp from "../3x1010/Pqp";
import ScreenAttract from "./ScreenAttract";
import ScreenIntro from "./ScreenIntro";
import ScreenGameOver from "./ScreenGameOver";
import Sounder from "../3x1010/sounder/Sounder";


export default class Main {
  constructor() {
    this.totalPreload = Main.CONFIGS.length + Main.SHEETS.length;
    this.preloaded = 0;
    Main.that = this;

  }

  init() {
    this.loadSave();
    Main.CRT = Main.savegame.crt;
    Main.FLASH = Main.savegame.flash;
    Main.VOLUME = Main.savegame.volume;

    this.loadConfig();
    this.initSettings()
    this.initTurn();
    /*if (Pqp.isMobile()) {
      jQuery(window).on("touchstart.main", this.disablePinch.bind(this));
      jQuery(window).on("touchmove.main", this.disablePinch.bind(this));
    }*/
  }
  /*
  disablePinch(e) {
    if (e.originalEvent.touches.length > 1) {
      //alert("CIAO")
      e.originalEvent.preventDefault();
    }

  }*/


  initSettings() {
    this.initVolume();
    this.initCrt();
  }

  initVolume() {

    jQuery(".js-less-volume").on("click", this.lessVolume.bind(this))
    jQuery(".js-more-volume").on("click", this.moreVolume.bind(this))
  }

  lessVolume() {
    Main.VOLUME--;
    if (Main.VOLUME < 0) {
      Main.VOLUME = Main.VOLUMES.length - 1;
    }
    this.applyVolume();
  }
  moreVolume() {
    Main.VOLUME++;
    if (Main.VOLUME === Main.VOLUMES.length) {
      Main.VOLUME = 0;
    }
    this.applyVolume();
  }

  applyVolume() {
    Main.savegame.volume = Main.VOLUME;
    Main.updateSavegame();
    let vol = Main.getCurrentVolume() * 100;
    if (vol === 0) {
      vol = "OFF"
    } else {
      vol = vol + "%";
    }
    jQuery(".js-volume-value").html("VOL. " + vol)
    //Sounder.setAllVolume(Main.getCurrentVolume())
    //debugger
    this.sounder.setVolume(Main.getCurrentVolume())
  }

  static getCurrentVolume() {
    return Main.VOLUMES[Main.VOLUME] / 100;
  }

  initCrt() {
    jQuery(".js-crt-control").on("click", this.toggleCrt.bind(this))
    this.applyCrt();
    jQuery(".js-flash-control").on("click", this.toggleFlash.bind(this))
    this.applyFlash();
  }

  toggleCrt() {
    Main.CRT = !Main.CRT;
    this.applyCrt();
  }

  applyCrt() {
    Main.savegame.crt = Main.CRT;
    Main.updateSavegame();

    if (Main.CRT) {
      jQuery(".js-crt-control").text("< CRT ON >")
      jQuery(".to-crt").addClass("crt");
    } else {
      jQuery(".js-crt-control").text("< CRT OFF >")
      jQuery(".to-crt").removeClass("crt");
    }
  }

  toggleFlash() {
    Main.FLASH = !Main.FLASH;
    this.applyFlash();
  }

  applyFlash() {
    Main.savegame.flash = Main.FLASH;
    Main.updateSavegame();

    if (Main.FLASH) {
      jQuery(".js-flash-control").text("< BLINK ON >")
      //this.set43();
    } else {
      jQuery(".js-flash-control").text("< BLINK OFF >")
      //this.setNormal();
    }
  }

  set43() {
    jQuery(window).on("resize", this.doSet43.bind(this));
    this.doSet43();
  }

  doSet43() {
    let rap = 640 / 400;
    let h = jQuery(window).height() * 0.96;
    let w = h * rap;
    jQuery(".js-main").height(h);
    jQuery(".js-main").width(w);
    
  }

  setNormal() {
    jQuery(window).off("resize");
    jQuery(".js-main").removeAttr("style");

  }


  loadConfig() {
    Config.load(Main.CONFIGS, this.configEventsHandlers.bind(this));
  }

  configEventsHandlers(e) {
    if (e.type === Config.EVENT_SINGLE_LOADED) {
      this.preloaded++;
      this.updatePreloader();
    }
    if (e.type === Config.EVENT_ALL_LOADED) {
      Assets.load(Main.SHEETS, this.assetsEventHandlers.bind(this));
    }

  }

  assetsEventHandlers(e) {
    if (e.type === Assets.EVENT_SINGLE_LOADED) {
      this.preloaded++;
      this.updatePreloader();
    }

    if (e.type === Assets.EVENT_ALL_LOADED) {


      setTimeout(this.pleaseWait.bind(this), 400)
      setTimeout(this.prepareSprites.bind(this), 500);
    }
  }

  pleaseWait() {
    jQuery(".js-preloader-text").text("PLEASE WAIT...");
  }

  prepareSprites() {
    Sprites.init(this.spritesEventsHandler.bind(this));
  }

  updatePreloader() {
    let perc = Math.floor(this.preloaded / this.totalPreload * 100);
    jQuery(".js-preloader-text").text("LOADING " + perc + "%");
  }


  spritesEventsHandler(e) {
    if (e.type === Sprites.EVENT_ALL_PREPARED) {

      let sounder = new Sounder(false, this.soundLoaded.bind(this));
      //let a = Game.THEMES_AND_SOUNDS;
      let a = Assets.getSounds();
      for (let x = 0; x < a.length; x++) {
        sounder.add(a[x].id, a[x].src);
      }
      sounder.init();
      this.sounder = sounder;
      sounder.setVolume(this.defaultVolume);
      
       //    Assets.load({ id: "theme0", src: "assets/sounds/themes/theme_ntsc.mp3" }, this.startGame.bind(this));
      //Assets.load({ id: "theme0", src: "assets/sounds/themes/theme_pal.mp3" }, this.startGame.bind(this));
      //Assets.load({ id: "theme0", src: "assets/sounds/themes/remakes/Lello Caliendo - Aztec challenge Evolution.mp3" }, this.startGame.bind(this));
    }
  }

  soundLoaded(e) {
    //console.log(e)
    if (e.type == Sounder.ALL_SOUNDS_READY) {
      this.applyVolume();
      this.cacheImages();
     
    }
    

  }

  cacheImages() {
    let images = Assets.getImages();
    let div = jQuery("<div></div>")
    /*div.css("transform", "scale(0.01)")
    div.css("position", "absolute")
    div.css("top", "0")
    div.css("opacity", "0.01")*/
    div.addClass("precache")


    jQuery("body").append(div);
    for (let x = 0; x < images.length; x++) {
      /*let img = new Image();
      img.src = images[x].src;
      jQuery(img).css("position", "absolute")
      jQuery(img).css("top", "0")

      div.append(jQuery(img))*/
      //console.log(images[x].id)
      let a = Sprites.getAllSprites(images[x].id)
      for (let y = 0; y < a.length; y++) {
        let img = new Image();
        img.src = a[y];
        jQuery(img).css("position", "absolute")
        jQuery(img).css("top", "0")
        div.append(jQuery(img))

      }
      

    }

    setTimeout(this.interactionRequest.bind(this,div), 100);
  }

  interactionRequest(toRemove) {
    //toRemove.remove();
    
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      toRemove.css("z-index", 1);
    } else {
      toRemove.hide();
    }
    //

    jQuery(".js-preloader").on("click", this.gotoScreenAttract.bind(this));
    //jQuery(".js-preloader").on("click", this.gotoScreenGameOver.bind(this));
    if (Pqp.isMobile()) {
      jQuery(".js-preloader-text").text("- TAP TO START -")
    } else {
      jQuery(".js-preloader-text").text("- CLICK TO START -")
    }

    jQuery(".js-settings").show();
  }

  gotoScreenAttract() {

    if (Pqp.isMobile()) {
      if (!Pqp.isIos()) {
        let element = jQuery("body").get(0);
        element.requestFullscreen();
      }
    }

    jQuery(".js-preloader").off("click");
    jQuery(".js-preloader").hide();
    this.screen = new ScreenAttract(this.screenAttractEventsHandler.bind(this));
    this.screen.init();
  }

  screenAttractEventsHandler(e) {
    if (e.type === ScreenAttract.EVENT_ENDED) {
      this.gotoScreenIntro(false);
    }
  }

  gotoScreenIntro(skipFirstPage) {
    this.screen.destroy();
    this.screen = new ScreenIntro(skipFirstPage,this.screenIntroEventsHandler.bind(this));
    this.screen.init();

  }

  screenIntroEventsHandler(e) {
    if (e.type === ScreenIntro.EVENT_ENDED) {
      this.gotoScreenStage(e.data);
    }

  }

  gotoScreenStage(o) {
    this.screen.destroy();
    this.screen = new ScreenStage(o, this.screenStageEventsHandler.bind(this));
    this.screen.init();
  }

  screenStageEventsHandler(e) {
    if (e.type === ScreenStage.EVENT_GAME_COMPLETED) {
      this.gotoScreenGameOver(e.data);
    }
    if (e.type === ScreenStage.EVENT_GIVEUP) {
      this.gotoScreenIntro(false);
    }
  }

  gotoScreenGameOver(data) {
    this.screen.destroy();
    jQuery(".js-preloader").off("click");
    jQuery(".js-preloader").hide();
    this.screen = new ScreenGameOver(data, this.screenGameOverEventsHandler.bind(this));
    this.screen.init();

  }

  screenGameOverEventsHandler(e) {
    if (e.type === ScreenGameOver.EVENT_ENDED) {
      this.gotoScreenIntro(e.won);
    }

  }



  loadSave() {
    if (Main.DEBUG_ALL_AVAIL) {
      window.localStorage.removeItem(Main.SAVEGAME_NAME)
    }
    let savegame = window.localStorage.getItem(Main.SAVEGAME_NAME);
    if (Main.savegame) {
      savegame = JSON.stringify(Main.savegame);
    }
    if (!Pqp.isNullOrEmpty(savegame)) {
      savegame = JSON.parse(savegame);
/*      console.log(savegame)
      debugger;*/
      if (savegame.data.length < ScreenIntro.SONGS.length) {
        for (let x = 0; x < ScreenIntro.SONGS.length; x++) {
          let song = ScreenIntro.SONGS[x];
          let lFound = false;
          for (let y = 0; y < savegame.data.length; y++) {
            if (savegame.data[y].id === song.id) {
              lFound = true;
              break;
            }
          }
          if (!lFound) {
            let o = new Object();
            o.id = song.id;
            o.played = 0;
            o.won = 0;
            o.deaths = 0;
            o.run = 0;
            o.distance = 0;
            o.spears = 0;
            savegame.data.push(o);

          }
        }

      }
      /*console.log(savegame)
      debugger*/


    } else {
      savegame = this.createEmptySavegame();
      window.localStorage.setItem(Main.SAVEGAME_NAME, JSON.stringify(savegame));
    }

    Main.savegame = savegame;
    console.log(Main.savegame)

  }

  createEmptySavegame() {
    let ret = new Object();
    ret.data = new Array();
    for (let x = 0; x < ScreenIntro.SONGS.length; x++) {
      let o = new Object();
      o.id = ScreenIntro.SONGS[x].id;
      o.played = 0;
      o.won = 0;
      o.deaths = 0;
      o.run = 0;
      o.distance = 0;
      o.spears = 0;
      ret.data.push(o)
    }
    ret.volume = Main.VOLUME;
    ret.crt = Main.CRT;
    ret.flash = Main.FLASH;
    ret.skipIntro = false;
    return ret;
  }

  static updateSavegame() {
    window.localStorage.setItem(Main.SAVEGAME_NAME, JSON.stringify(Main.savegame));
    //console.log(Main.savegame)
  }

  static getThemeOnSavegame(id) {
    for (let x = 0; x < Main.savegame.data.length; x++) {
      if (Main.savegame.data[x].id === id) {
        return Main.savegame.data[x];
      }
    }
    return null;
  }

  initTurn() {
    if (Pqp.isMobile()) {
      jQuery(window).on("resize.info", jQuery.proxy(this.onCheckPortrait, this));
      this.onCheckPortrait();
    }
  }

  onCheckPortrait() {
    if (Pqp.isMobile()) {
      var w = jQuery(window).outerWidth();
      var h = jQuery(window).outerHeight();
      if (h > w) {
        jQuery(".mcTurn").show();
      } else {
        jQuery(".mcTurn").hide();
      }
    }
  }

}


Main.SAVEGAME_NAME = "savegame_ac";


Main.CONFIGS = [

];

Main.SHEETS = [
  { id: "debris0", src: "assets/debris0.png", width: 608, height: 164 },
  { id: "debris1", src: "assets/debris1.png", width: 640, height: 188 },
  { id: "debris2", src: "assets/debris2.png", width: 640, height: 188 },
  { id: "spearmen", src: "assets/spearmen.png", width: 96, height: 256 },
  { id: "cornholio", src: "assets/cornholio.png", width: 104, height: 392 },
  { id: "dead", src: "assets/dead.png", width: 284, height: 204 },
  { id: "spear", src: "assets/spear.png", width: 128, height: 12 },
  { id: "pyramid", src: "assets/pyramid.png", width: 768, height: 192 },
  { id: "logo", src: "assets/logo.png", width: 512, height: 384 },
  { id: "intro", src: "assets/sounds/intro.mp3" },
  { id: "smallloop", src: "assets/sounds/smallloop.wav" },
  { id: "spear0", src: "assets/sounds/spear0.mp3" },
  { id: "spear1", src: "assets/sounds/spear1.mp3" },
  { id: "spear2", src: "assets/sounds/spear2.mp3" },
  { id: "spear3", src: "assets/sounds/spear3.mp3" },
  { id: "death", src: "assets/sounds/death.mp3" },
  { id: "qbert", src: "assets/sounds/qbert.wav" },
  { id: "tarararan", src: "assets/sounds/tarararan.mp3" },
  { id: "ending", src: "assets/sounds/ending.mp3" },
  { id: "aztec", src: "assets/aztec.png", width: 1216, height: 160 },
  { id: "challenge", src: "assets/challenge.png", width: 1216, height: 160 },
  { id: "tribute", src: "assets/tribute.png", width: 1216, height: 160 },
  { id: "front", src: "assets/front.png", width: 96, height: 164 },
  { id: "sorry", src: "assets/sorry.png", width: 480, height: 352 },
  { id: "floor", src: "assets/floor.png", width: 32, height: 128 },
  { id: "karateka", src: "assets/karateka.png", width: 176, height: 176 },
  { id: "girl", src: "assets/girl.png", width: 152, height: 184 },
];

Main.VOLUMES = [100, 50, 25, 10, 1, 0];
Main.VOLUME = 3;
Main.CRT = true;
Main.FLASH = true;
Main.savegame = null;
Main.DEBUG_ALL_AVAIL = false;